// 두 지점 간의 거리를 계산하는 함수
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371 * 1000; // 지구의 반지름 (단위: m)
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // 두 지점 간의 직선 거리 (단위: m)
  return distance;
};

const alertTriggeredFlags = {};

// 주어진 반경 내에 있는지 여부를 확인하는 함수
const isWithinRadius = (centerLat, centerLon, targetLat, targetLon, radius) => {
  const distance = calculateDistance(
    centerLat,
    centerLon,
    targetLat,
    targetLon
  );
  return distance <= radius || distance === 0;
};
export const checkLocationWithinRadius = (
  centerLat,
  centerLon,
  targetLat,
  targetLon,
  radius,
  index,
  serial
) => {
  // serial과 index를 합친 유니크한 키 생성
  const key = `${serial}-${index}`;

  const withinRadius = isWithinRadius(
    centerLat,
    centerLon,
    targetLat,
    targetLon,
    radius,
    index
  );

  // alertTriggeredFlags 초기화
  if (!alertTriggeredFlags[key]) {
    alertTriggeredFlags[key] = false;
  }

  if (withinRadius && !alertTriggeredFlags[key]) {
    alertTriggeredFlags[key] = true;
    setTimeout(() => {
      alertTriggeredFlags[key] = false;
    }, 5 * 60 * 1000);
    return `${serial}의 현재 위치가 ${index + 1}번 반경에 있습니다.`;
  } else {
    return false;
  }
};
